import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-505ed9e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position position-1 position-1-1" }
const _hoisted_2 = { class: "position position-1 position-1-2" }
const _hoisted_3 = { class: "position position-1 position-1-3" }
const _hoisted_4 = { class: "position position-2" }
const _hoisted_5 = { class: "position position-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position position-4" }, " 預り金還付 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position position-5" }, " 1 ", -1))
const _hoisted_8 = { class: "position position-6" }
const _hoisted_9 = { class: "position position-7" }
const _hoisted_10 = { class: "position position-8" }
const _hoisted_11 = { class: "position position-9" }
const _hoisted_12 = { class: "position position-10" }
const _hoisted_13 = { class: "position position-11" }
const _hoisted_14 = { class: "position position-12" }

import { reactive, ref, nextTick } from 'vue'
import { t } from '@/plugins/i18n'
import html2canvas from 'html2canvas'
import { Canvas2Image } from './canvas2image'
import { getSign } from '@/apis/oss'
import { uid } from 'uid/dist/index.js'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  props: {
  form: {
    type: Object,
    default: null
  }
},
  emits: ['success', 'close'],
  setup(__props, { emit: emits }) {

const props = __props




const data = reactive({
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  day: new Date().getDate(),
  // oss上传链接
  uploadUrl: '',
  // 图片链接
  imgUrl: ''
})

const uploadParams: any = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: '',
  file: null
})

const applicationRef = ref(null)

nextTick(() => {
  toPic(applicationRef.value)
})

const toPic = (dom: any) => {
  const canvas2 = document.createElement('canvas')
  const w = parseInt(window.getComputedStyle(dom).width)
  const h = parseInt(window.getComputedStyle(dom).height)
  const context: any = canvas2.getContext('2d')
  context.scale(1, 1)
  canvas2.width = w
  canvas2.height = h
  html2canvas(dom, { canvas: canvas2 }).then((canvas: any) => {
    const img:any = Canvas2Image.convertToPNG(canvas, w, h)
    getOssSign(img).then(() => {
      ossUpload()
    })
  })
}

/**
 * 获取阿里云上传签名等参数
 */
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    getSign()
      .then((res: any) => {
        if (res.code === '0') {
          const resData = res.data
          uploadParams.key = `${resData.dir}${uid()}.png`
          uploadParams.name = uploadParams.key
          uploadParams.policy = resData.policy
          uploadParams.OSSAccessKeyId = resData.accessId
          uploadParams.signature = resData.signature
          uploadParams.file = base2File(file.src, uploadParams.name)

          data.uploadUrl = resData.host.replace(/http[s]?:/, location.protocol)
          data.imgUrl = `${resData.customDomain}/${uploadParams.key}`
        } else {
          emits('close')
        }
        resolve(true)
      })
      .catch(error => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
      })
  })
}

// oss上传
const ossUpload = () => {
  const formData = new FormData()
  const { key, name, policy, OSSAccessKeyId, signature, file } = uploadParams
  formData.append('OSSAccessKeyId', OSSAccessKeyId)
  formData.append('signature', signature)
  formData.append('key', key)
  formData.append('policy', policy)
  formData.append('success_action_status', uploadParams.success_action_status)
  formData.append('name', name)
  formData.append('file', file)
  axios({
    url: data.uploadUrl,
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(res => {
    emits('success', data.imgUrl)
  })
}

// base64转file对象
const base2File = (dataurl: any, filename: any) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['applicationRef'] = _value
      applicationRef.value = _value
    },
    class: "uploadApplication"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(data).year), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(data).month), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).day), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString((__props.form.withdrawAmountRmb * 100) * (__props.form.exchangeRate * 100) / 10000), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(data).year) + " 年 " + _toDisplayString(_unref(data).month) + " 月 " + _toDisplayString(_unref(data).day) + " 日 ", 1),
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, _toDisplayString((__props.form.withdrawAmountRmb * 100) * (__props.form.exchangeRate * 100) / 10000), 1),
    _createElementVNode("div", _hoisted_9, _toDisplayString((__props.form.withdrawFee * 100) * (__props.form.exchangeRate * 100) / 10000), 1),
    _createElementVNode("div", _hoisted_10, _toDisplayString(__props.form.withdrawAmountJp), 1),
    _createElementVNode("div", _hoisted_11, _toDisplayString(__props.form.bankName), 1),
    _createElementVNode("div", _hoisted_12, _toDisplayString(__props.form.bankAddress), 1),
    _createElementVNode("div", _hoisted_13, _toDisplayString(__props.form.kzType === '1' ? _unref(t)('普通') : _unref(t)('综合')), 1),
    _createElementVNode("div", _hoisted_14, _toDisplayString(__props.form.beneficiaryName), 1)
  ], 512))
}
}

})